const Contact = () => {
    return ( 
        <div className="contact default-pad">
            <h2>Contact Us - Youga</h2>
            <p>
                    Thank you for your interest in Youga! We're here to assist you and provide any information you need. Please feel free to reach out to us through the following contact details:
                    <br /><br />
                    Phone: +1 (555) 123-4567
                    <br />
                    <a href="https://www.google.com/" target="_blank">Email: info@youga.com</a>
                    <br /><br />
            <p>
                    Our friendly and knowledgeable customer service team is available to answer your inquiries, provide class schedules, and assist with any concerns you may have. Whether you have questions about our yoga classes, upcoming events, or general wellness inquiries, we're here to help.
                    <br /><br />
                    <h2>Studio adress</h2>
                    <a href="https://goo.gl/maps/Tso6ebHK3WZVWpou9" target="_blank">
                    123 Serenity Lane,
                    Yourtown, ABC 12345,
                    United States</a>
                    <br /><br />
                    Youga is conveniently located in the heart of Yourtown, making it easily accessible for local residents and visitors alike. Our serene studio space is designed to provide a tranquil environment where you can immerse yourself in the practice of yoga.
                    <br /><br />
                    <p>
                        <h2>Connect with Us:</h2>
                        Website: 
                        <a href="" target="_blank">www.youga.comb </a>
                        <br />
                        Facebook:
                        <a href="" target="_blank">www.facebook.com/youga</a>
                        <br />
                        Instagram:
                        <a href="" target="_blank">www.instagram.com/youga_studio</a>

                        <br /><br />

                        Stay updated with the latest news, events, and inspirations from Youga by following our social media channels and visiting our website. We regularly share valuable content, yoga tips, and motivational posts to support your wellness journey.

                        We value your feedback and suggestions, so please don't hesitate to get in touch. Your satisfaction and well-being are our top priorities at Youga.
                    </p>
            </p>
            </p>
        </div>

        
     );
}
 
export default Contact;